import backend from '@common/backend';

const BASE = '/currentLearningFlow';

export const getCurrentLearningFlow = async () => backend.get(`${BASE}`);
